import { UpdateHub } from "@ogaf/scripts/UpdateHub/UpdateHub";
import { TPpdTaskBase } from "../App/PpdBaseTask";
export class UpdateHubPpd extends UpdateHub {

    constructor() {
        super();
    }

    public override onSignalRConnection(message: string, uid: string) {
        switch (message) {
            default:
                break;
        }
    }

}

Connection = new UpdateHubPpd().Connection;